<div class="row">
	<div class="col-xs-12">
	{{#if noValueSpecsAvailable}}
	<div class="alert alert-info">
		<strong>{{TR 'Für diese Gerätekategorie stehen keine vordefinierten Werte zur Verfügung.'}}</strong>
	</div>
	{{else}}
	<center>
		{{#if showNoValuesMessage}}
		<div class="alert alert-warning">
			<strong>{{noValuesMessage}}</strong>
		</div>

		{{else}}
		<select multiple="multiple" class="multi-select" id="value-multi-select" name="values">
		{{#each options}}
			<optgroup label="{{TR name}}">
			{{#each values}}
				<option value="{{uniqueId}}" {{#if ../../showExtendedInfos}}sub_info="<small><span class='text-muted'>{{type}}_{{nr}} L{{length}} UC{{update_class}}</span></small>"{{/if}} {{VALUE_SELECTED ../../selectedValues this}}>{{TR_DATAPOINT_CATEGORY group name}}</option>
			{{/each}}
			</optgroup>
		{{/each}}
		</select>
		{{/if}}
	</center>
	{{/if}}
	</div>
</div>
{{#unless hideInfo}}
<div class="row m-t-30 m-b-5">
	<div class="col-xs-12 text-center">
		{{#COMPARE updateClass '==' 0}}
		{{TR "Hinzugefügte Werte werden der Standard-Aktualisierungsklasse zugewiesen."}}
		{{else}}
		{{TR "Hinzugefügte Werte werden der Aktualisierungsklasse"}} {{updateClass}} {{TR "zugewiesen."}}
		{{/COMPARE}}
	</div>
</div>
{{/unless}}
